import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector, Type, EmbeddedViewRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  open<T>(component: Type<T>, data?: any) {
    const subject = new Subject<any>();
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    if (data) {
      Object.assign(componentRef.instance as object, data);
    }

    (componentRef.instance as any).close = () => {
      subject.next(null);
      subject.complete();
      this.appRef.detachView(componentRef.hostView);
      const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      document.body.removeChild(domElem);
    };

    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    return {
      afterClosed: () => subject.asObservable(),
      close: (componentRef.instance as any).close
    };
  }
} 